import { render, staticRenderFns } from "./EmpleadoTarjeta.vue?vue&type=template&id=4ecda11c&"
import script from "./EmpleadoTarjeta.vue?vue&type=script&lang=js&"
export * from "./EmpleadoTarjeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports